import * as React from 'react';
import { useSelector } from 'react-redux';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { trackListingCompilationClick, trackListingCompilationsShow } from './tracking';
import { getImageUrl, getListingCompilationUrl } from './utils';
import { ListingCompilation, ListingCompilationLayout } from '../../components/ListingCompilations';
import { Section } from '../../components/Section';
import { selectBlackFriday } from '../../selectors/blackFriday';
import { selectCurrentRegion } from '../../selectors/currentRegion';
import { selectListingCompilations } from '../../selectors/promosPage';

export const ListingCompilationsContainer: React.FC = () => {
  const listingCompilations = useSelector(selectListingCompilations);
  // Не всё берём с бэка, потому что в будущем url-ы и картинки могут быть разными на десктопе и мобвебе.
  // Бэк не должен знать о таких деталях.
  const { listingCompilations: listingCompilationSettings } = useSelector(selectBlackFriday);

  const currentRegion = useSelector(selectCurrentRegion);

  if (!listingCompilations.length || !listingCompilationSettings) {
    return null;
  }

  return (
    <Section title="Подборки суперскидок" data-testid="ListingCompilationsSection">
      <ActionAfterViewObserver callback={trackListingCompilationsShow}>
        <ListingCompilationLayout>
          {listingCompilations.map(item => (
            <div key={item.type} onClick={() => trackListingCompilationClick(item.type)}>
              <ListingCompilation
                imageUrl={getImageUrl(item, listingCompilationSettings)}
                subtitle={item.subtitle}
                title={item.title}
                url={getListingCompilationUrl(item, listingCompilationSettings, currentRegion)}
              />
            </div>
          ))}
        </ListingCompilationLayout>
      </ActionAfterViewObserver>
    </Section>
  );
};
